import { setEnvironmentRequestUri } from '@libs/store';
import { TRequestUri } from '@libs/types';
import React, { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router';

export const DeepLinkPage = () => {
    const navigation = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const requestUri = {
            path: location.pathname,
        } as TRequestUri;
        if (searchParams.size !== 0) {
            requestUri.data = Object.fromEntries(searchParams.entries());
        }
        setEnvironmentRequestUri(requestUri);
        navigation('/', { replace: true });
    }, [location.pathname, navigation, searchParams]);

    return <h1>Loading</h1>;
};
